import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { FEATURE_NAME } from './local-storage-service-stack-form.constant';
import { ZefTranslationsService } from '@zerops/zef/translations';

const en = {
  nonHaTitle: 'Local Storage is not highly available',
  nonHaDesc: `<p>The volume lives on a <strong>single physical machine</strong>, together with every runtime service
    that mounts it. If that hardware fails, or when maintenance requires moving workloads elsewhere, Zerops moves
    the volume to a healthy server and every connected runtime service goes through a small outage
    &mdash; stop, move, start. <strong>Recovering the volume and its data is not guaranteed.</strong></p>
    <p>We recommend keeping backups enabled to avoid data loss. Read the
    <a data-zui-new-docs="local-storage/overview">Local Storage documentation</a>
    before you rely on it in production.</p>`,
  nameTitle: 'Local storage name',
  nameDesc: `Select on which name will your service <strong>communicate with other services</strong> within the project.
    Runtime services mount the volume by this hostname through the <strong>volume</strong> key in zerops.yaml.`,
  nameLabel: 'Name',
  namePlaceholder: 'Name your local storage …',
  scalingTitle: 'Automatic Scaling',
  scalingDesc: `The service always runs as a <strong>single container</strong> that owns the volume, so Zerops scales it
    only vertically by adjusting that container's resources. Disk is the size of the volume itself &mdash; it grows
    automatically as the data on it grows, but it <strong>never shrinks</strong>. Find all the specifics in the
    <a data-zui-new-docs="features/scaling-ha">Zerops scaling documentation</a>.`
};

export type LocalStorageServiceStackFormTranslations = typeof en;

@NgModule({ exports: [ TranslocoModule ] })
export class LocalStorageServiceStackFormTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
